import { EcommerceAPI } from "../Client";

const commentRulesUrl = "/admin/social/comment-rules";
const commentRuleUrl = (id) =>
  `${commentRulesUrl}/${encodeURIComponent(id)}`;

export const createCommentRuleApi = (body) =>
  EcommerceAPI.post(commentRulesUrl, body);

// body: { configuration: { ...commentRule }, comment }
export const previewCommentRuleApi = (body) =>
  EcommerceAPI.post(`${commentRulesUrl}/preview`, body);

export const getCommentRulesApi = ({ page = 0, size = 10 } = {}) =>
  EcommerceAPI.get(commentRulesUrl, { params: { page, size } });

export const getCommentRuleApi = (id) =>
  EcommerceAPI.get(commentRuleUrl(id));

export const updateCommentRuleApi = (id, body) =>
  EcommerceAPI.put(commentRuleUrl(id), body);

export const deleteCommentRuleApi = (id) =>
  EcommerceAPI.delete(commentRuleUrl(id));
